import { Route } from "@dashboard/components/Router";
import { parse as parseQs } from "qs";
import React from "react";
import { RouteComponentProps, Switch } from "react-router-dom";

import { pageDetailsPath, pagesListPath, PageUrlQueryParams } from "./urls";
import PageDetailsComponent from "./views/PageDetails";
import PagesListComponent from "./views/PagesList";

const PageDetails = ({ match }: RouteComponentProps<{ id: string }>) => {
  const qs = parseQs(location.search.substr(1));
  const params: PageUrlQueryParams = qs;

  return <PageDetailsComponent id={decodeURIComponent(match.params.id)} params={params} />;
};

const PagesRouter = () => (
  <Switch>
    <Route exact component={PagesListComponent} path={pagesListPath} />
    <Route component={PageDetails} path={pageDetailsPath(":id")} />
  </Switch>
);

export default PagesRouter;
